/* tslint:disable */
/* eslint-disable */
// @ts-ignore
import * as Types from '../../../../global-graphql-types'

import { DocumentNode } from 'graphql'
export type LotBaseFragment = {
  __typename: 'Lot'
  id: number
  name: string
  active: boolean
  lotUrl: string
  lotPath: string
  address: string | null
  fullAddress: string
  facebook: string | null
  instagram: string | null
  twitter: string | null
  tiktok: string | null
  website: string | null
  referralEnabled: boolean
  image: {
    __typename: 'LotImage'
    horizontalStretch: string
    medium: string
    original: string | null
    present: boolean
  } | null
  foodImage: { __typename: 'LotFoodImage'; medium: string } | null
}

export const LotBaseFragment = ({
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'lotBaseFragment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Lot' }
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'active' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lotUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lotPath' } },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fullAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'facebook' } },
          { kind: 'Field', name: { kind: 'Name', value: 'instagram' } },
          { kind: 'Field', name: { kind: 'Name', value: 'twitter' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tiktok' } },
          { kind: 'Field', name: { kind: 'Name', value: 'website' } },
          { kind: 'Field', name: { kind: 'Name', value: 'referralEnabled' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'horizontalStretch' }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'medium' } },
                { kind: 'Field', name: { kind: 'Name', value: 'original' } },
                { kind: 'Field', name: { kind: 'Name', value: 'present' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'foodImage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'medium' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown) as DocumentNode
